import React, { Component } from 'react'
import { getValueCookie } from '../../../services/cookieService';
import { create_Delete_Update_Information, getInformationWithData } from '../../../services/CABE';
import "../../../css/inventory-style.css"
import "../../../css/general-style.css"
import '../../../css/table-responsive.css'
import { getIndexElement } from '../../../functions/searchInObject';
import { pricesFormat } from '../../../functions/pricesFormat';
import { ItemDesc, NumberFormat, OrderArray } from '../../../functions/generalFunctions';
import ExcelDocument from '../../../components/ExcelDocument';
import { getActualDateQuery, getDateFromReports } from '../../../functions/dateFormat';
import { ReportChangePriceMargin, ReportOnlyChangePriceMargin } from '../../../functions/generateDataSetExcel';
import LoadingWindow from '../../../components/LoadingWindow';
import { BsFileArrowUpFill, BsFileArrowDownFill } from "react-icons/bs";
import { AiOutlineReload, AiOutlineSearch, AiFillDollarCircle } from "react-icons/ai";
import CSVDocument from '../../../components/CSVDocument';
import { confirmCloseAlert } from '../../../functions/alerts';
import ModalOrders from '../../../components/ModalComponent';
import { formatInputDateQuery } from '../../../functions/dateFormat';
import styles from '../../../css/MargenesPrecio.module.css';

// Menu
import { Menu } from "../../../components/Menu/Menu";

export default class CalculateMarginPrices extends Component {
    constructor(props) {
        super(props)
        this.ModalLoading = React.createRef();
    }
    state = {
        Products: [],
        ProductsFilter: [],
        TableHeaders: [],
        AuxTableHeaders: [],
        PricesLevels: [{ name: 'All', Level: '0' }],
        flag: true,
        bigHead: true,
        minwidth: '200',
        NewWork: false,
        InternalId: 0,
        showModal1: false,
        MarginPricesHistoryHeader: [],

        pageNumers: [],
        currentPage: 1,
        ProductsPerPage: 70,
        lastIndex: 70,
        firstIndex: 0,
        textFilter: ''
    }

    async getProductsMargin() {
        let PricesLevels = [{ name: 'All', Level: '0' }]
        this.ModalLoading.current.showState(true);
        if (getValueCookie('CompanyId') !== '6') {
            const data = {
                idCompany: Number(getValueCookie('CompanyId')),
                type: 'CalculatePriceMargins',
            }
            const dataCorrelative = {
                idCompany: getValueCookie('CompanyId'),
                type: 'CalculatePriceMargins',
            }

            const result = await getInformationWithData('/Items/margin', data)
            const correlative = await getInformationWithData('/sales/get/correlative', dataCorrelative)
            if (result.status.code === 1) {
                let temporal = []
                // console.log(result)
                for (const item of result.result) {
                    const index = getIndexElement(temporal, 'ItemCode', item.ItemCode)
                    if (index === -1) {
                        const it = {
                            ItemCode: item.ItemCode,
                            ItemCodeDesc: item.ItemCodeDesc,
                            ProductLine: item.ProductLineDesc,
                            UnitCost: item.LastTotalUnitCost,
                            Change: false,
                            PricesLevels: []

                        }
                        const priceLev = {
                            PriceLevel: item.CustomerPriceLevel,
                            LevelCost: item.DiscountMarkup1 === 0 ? '-' : item.DiscountMarkup1,
                            RealMargin: item.DiscountMarkup1 === 0 ? '-' : ((Number(item.DiscountMarkup1) - Number(item.LastTotalUnitCost)) / (Number(item.DiscountMarkup1))) * 100,
                            NewLevelCost: item.DiscountMarkup1 === 0 ? 0 : item.DiscountMarkup1,
                            NewRealMargin: item.DiscountMarkup1 === 0 ? 0 : ((Number(item.DiscountMarkup1) - Number(item.LastTotalUnitCost)) / (Number(item.DiscountMarkup1))) * 100,

                        }
                        it.PricesLevels.push(priceLev)
                        temporal.push(it)
                    } else {
                        const priceLev = {
                            PriceLevel: item.CustomerPriceLevel,
                            LevelCost: item.DiscountMarkup1 === 0 ? '-' : item.DiscountMarkup1,
                            RealMargin: item.DiscountMarkup1 === 0 ? '-' : ((Number(item.DiscountMarkup1) - Number(temporal[index].UnitCost)) / (Number(item.DiscountMarkup1))) * 100,
                            NewLevelCost: item.DiscountMarkup1 === 0 ? 0 : item.DiscountMarkup1,
                            NewRealMargin: item.DiscountMarkup1 === 0 ? 0 : ((Number(item.DiscountMarkup1) - Number(temporal[index].UnitCost)) / (Number(item.DiscountMarkup1))) * 100,
                        }
                        temporal[index].PricesLevels.push(priceLev)
                    }
                }
                let headers = []
                for (const item of temporal) {
                    for (const pricelevel of item.PricesLevels) {
                        const index = getIndexElement(headers, 'Level', pricelevel.PriceLevel)
                        const index2 = getIndexElement(PricesLevels, 'Level', pricelevel.PriceLevel)
                        if (index === -1) {
                            const head = {
                                Level: pricelevel.PriceLevel,
                                Title1: "Level " + pricelevel.PriceLevel,
                                Title2: "Real Mark-Up Level " + pricelevel.PriceLevel,
                                Title3: "New Level " + pricelevel.PriceLevel,
                                Title4: "New Real Mark-Up Level " + pricelevel.PriceLevel,
                            }
                            headers.push(head)
                        }
                        if (index2 === -1) {
                            PricesLevels.push({ name: 'Price Level ' + pricelevel.PriceLevel, Level: String(pricelevel.PriceLevel) })
                        }
                    }


                }
                for (const item of temporal) {
                    if (item.PricesLevels.length !== headers.length) {
                        for (const head of headers) {
                            const index = getIndexElement(item.PricesLevels, 'PriceLevel', head.Level)
                            if (index === -1) {
                                const priceLev = {
                                    PriceLevel: head.Level,
                                    LevelCost: '-',
                                    RealMargin: '-',
                                    NewLevelCost: 0,
                                    NewRealMargin: 0
                                }
                                item.PricesLevels.push(priceLev)
                            }
                        }
                    }
                }
                temporal = await ItemDesc(temporal, 'ItemCodeDesc', 'ItemCode')
                this.setState({ InternalId: correlative.data[0].correlative, Products: temporal, ProductsFilter: temporal.slice(this.state.firstIndex, this.state.lastIndex), TableHeaders: headers, PricesLevels: PricesLevels, AuxTableHeaders: headers, minwidth: (headers.length * 120) + 'vh', NewWork: true,textFilter:'' })
                document.getElementById("CheckChangeMarginPrice0").checked = true;
                this.checkFilter("CheckChangeMarginPrice0", { name: 'All', Level: '0' })
            }
        } else if (getValueCookie('CompanyId') === '6') {
            const data = {
                company: getValueCookie('Company'),
                idcompany: Number(getValueCookie('CompanyId')),
                priceLevel: '1',
                Component: null,
                type: 'CalculatePriceMargins',
            }
            // const dataCorrelative = {
            //     company: getValueCookie('Company'),
            //     idCompany: getValueCookie('CompanyId'),
            //     priceLevel: '1',
            //     Component: null,
            //     type: 'CalculatePriceMargins',
            // }

            const invent = await getInformationWithData('/Items/get', data)
            const correlative = await getInformationWithData('/sales/get/correlative', getValueCookie)
            if (getValueCookie('CompanyId') === '6') {
                data.company = 'Mayaland Atlanta'
                data.idcompany = '3'
                const respuesta2 = await getInformationWithData('/Items/get', data);


                invent.status.code = respuesta2.status.code
                for (const item of respuesta2.data) {
                    const index = getIndexElement(invent.data, 'itemCode', item.itemCode)
                    if (index !== -1) {
                        invent.data = invent.data.splice(index, 1)
                    }
                }
                invent.data = invent.data.concat(respuesta2.data)

                if (invent.status.code === 1) {
                    let temporal = []
                    for (const item of invent.data) {
                        const index = getIndexElement(temporal, 'itemCode', item.itemCode)
                        if (index === -1) {
                            const it = {
                                ItemCode: item.itemCode,
                                ItemCodeDesc: item.abbreviatedDesc,
                                ProductLine: item.ProductLineDesc,
                                UnitCost: item.LastTotalUnitCost / 0.95,
                                PricesLevels: []

                            }
                            if (!item.UnitPriceALT) {
                                item.UnitPriceALT = item.UnitPrice
                            }


                            const priceLev = {
                                PriceLevel: '1',
                                LevelCost: item.UnitPriceALT === 0 ? '-' : item.UnitPriceALT,
                                RealMargin: item.UnitPriceALT === 0 ? '-' : ((Number(item.UnitPriceALT) - (Number(item.LastTotalUnitCost) / 0.95)) / (Number(item.UnitPriceALT))) * 100,
                                NewLevelCost: item.UnitPriceALT === 0 ? 0 : item.UnitPriceALT,
                                NewRealMargin: item.UnitPriceALT === 0 ? 0 : ((Number(item.UnitPriceALT) - (Number(item.LastTotalUnitCost) / 0.95)) / (Number(item.UnitPriceALT))) * 100,

                            }
                            if (priceLev.RealMargin > 15 && priceLev.LevelCost > 0) {
                                it.PricesLevels.push(priceLev)
                            }

                            temporal.push(it)
                        } else {
                            const priceLev = {
                                PriceLevel: '1',
                                LevelCost: item.UnitPriceALT === 0 ? '-' : item.UnitPriceALT,
                                RealMargin: item.UnitPriceALT === 0 ? '-' : ((Number(item.UnitPriceALT) - Number(temporal[index].UnitCost)) / (Number(item.UnitPriceALT))) * 100,
                                NewLevelCost: item.UnitPriceALT === 0 ? 0 : item.UnitPriceALT,
                                NewRealMargin: item.UnitPriceALT === 0 ? 0 : ((Number(item.UnitPriceALT) - Number(temporal[index].UnitCost)) / (Number(item.UnitPriceALT))) * 100,
                            }
                            if (priceLev.RealMargin > 15 && priceLev.LevelCost > 0) {
                                temporal[index].PricesLevels.push(priceLev)
                            }
                        }
                    }

                    let headers = []
                    for (const item of temporal) {
                        for (const pricelevel of item.PricesLevels) {
                            const index = getIndexElement(headers, 'Level', pricelevel.PriceLevel)
                            const index2 = getIndexElement(PricesLevels, 'Level', pricelevel.PriceLevel)
                            if (index === -1) {
                                const head = {
                                    Level: pricelevel.PriceLevel,
                                    Title1: "Level " + pricelevel.PriceLevel,
                                    Title2: "Real Mark-Up Level " + pricelevel.PriceLevel,
                                    Title3: "New Level " + pricelevel.PriceLevel,
                                    Title4: "New Real Mark-Up Level " + pricelevel.PriceLevel,
                                }
                                headers.push(head)
                            }

                            if (index2 === -1) {
                                PricesLevels.push({ name: 'Price Level ' + pricelevel.PriceLevel, Level: String(pricelevel.PriceLevel) })
                            }
                        }


                    }
                    for (const item of temporal) {
                        if (item.PricesLevels.length !== headers.length) {
                            for (const head of headers) {
                                const index = getIndexElement(item.PricesLevels, 'PriceLevel', head.Level)
                                if (index === -1) {
                                    const priceLev = {
                                        PriceLevel: head.Level,
                                        LevelCost: '-',
                                        RealMargin: '-',
                                        NewLevelCost: 0,
                                        NewRealMargin: 0
                                    }
                                    item.PricesLevels.push(priceLev)
                                }
                            }
                        }
                    }

                    temporal = await ItemDesc(temporal, 'ItemCodeDesc', 'ItemCode')

                    this.setState({ InternalId: correlative.data[0].correlative, Products: temporal, ProductsFilter: temporal.slice(this.state.firstIndex, this.state.lastIndex), TableHeaders: headers, PricesLevels: PricesLevels, AuxTableHeaders: headers, NewWork: true, textFilter:'' })
                    document.getElementById("CheckChangeMarginPrice0").checked = true;
                    this.checkFilter("CheckChangeMarginPrice0", { name: 'All', Level: '0' })
                }

            }


        }
        this.setState({ PricesLevels: PricesLevels })
        this.pagination()
        this.ModalLoading.current.showState(false);
    }

    contains(parametro, busqueda) {
        if (parametro && busqueda) {
            return parametro.toString().toLowerCase().includes(busqueda.toLocaleLowerCase())
        }
        return false
    }

    searchPriceMargin = e => {
        const checkboxList = document.getElementsByClassName('PricesLevels')
        let PricesLevels = []
        for (const PriceLevel of checkboxList) {
            if (PriceLevel.checked) {
                PricesLevels.push(PriceLevel.value)
            }
        }

        let search = e;
        this.setState({ textFilter: search })
        if (search) {
            let Products = this.state.Products.slice(this.state.firstIndex, this.state.lastIndex).filter((item) => {
                if (((
                    this.contains(item.ItemCode, search) ||
                    this.contains(item.ProductLine, search) ||
                    this.contains(item.ItemCodeDesc, search)

                ))
                ) {
                    return item
                } else {
                    return null
                }
            });
            let temporalProducts = []
            for (const Item of Products) {
                let newPricesLevels = []
                for (const Level of PricesLevels) {
                    const index = getIndexElement(Item.PricesLevels, 'PriceLevel', String(Level))

                    if (index !== -1) {
                        newPricesLevels.push(Item.PricesLevels[index])
                    }
                }

                temporalProducts.push({
                    ItemCode: Item.ItemCode,
                    ItemCodeDesc: Item.ItemCodeDesc,
                    ProductLine: Item.ProductLine,
                    UnitCost: Item.UnitCost,
                    Change: Item.Change,
                    PricesLevels: newPricesLevels,
                    LastDueDate: Item.LastDueDate
                })
            }
            this.setState({ ProductsFilter: temporalProducts });
        } else {
            let Products = this.state.Products.slice(this.state.firstIndex, this.state.lastIndex)
            let temporalProducts = []
            for (const Item of Products) {
                let newPricesLevels = []
                for (const Level of PricesLevels) {
                    const index = getIndexElement(Item.PricesLevels, 'PriceLevel', String(Level))

                    if (index !== -1) {
                        newPricesLevels.push(Item.PricesLevels[index])
                    }
                }

                temporalProducts.push({
                    ItemCode: Item.ItemCode,
                    ItemCodeDesc: Item.ItemCodeDesc,
                    ProductLine: Item.ProductLine,
                    UnitCost: Item.UnitCost,
                    Change: Item.Change,
                    PricesLevels: newPricesLevels,
                    LastDueDate: Item.LastDueDate
                })
            }
            this.setState({ ProductsFilter: temporalProducts });
        }


    }

    OrderPriceMargins(option) {
        var temporal = this.state.ProductsFilter
        switch (option) {
            case "ItemCode":
                temporal = OrderArray(temporal, "ItemCode", this.state.flag)
                this.setState({ ProductsFilter: temporal, flag: !this.state.flag })
                break;
            case "ProductLine":
                temporal = OrderArray(temporal, "ProductLine", this.state.flag)
                this.setState({ ProductsFilter: temporal, flag: !this.state.flag })
                break;
            case "UnitCost":
                temporal = OrderArray(temporal, "UnitCost", this.state.flag)
                this.setState({ ProductsFilter: temporal, flag: !this.state.flag })
                break;
            default:
                break;
        }
    }

    OrderByPriceLevel(position, key) {
        var arreglo = this.state.ProductsFilter
        var l = arreglo.length

        if (this.state.flag) {
            for (let i = 0; i < l; i++) {
                for (let j = 0; j < l - 1 - i; j++) {
                    if ((arreglo[j].PricesLevels[position][key] === '-' ? '0' : arreglo[j].PricesLevels[position][key]) > (arreglo[j + 1].PricesLevels[position][key] === '-' ? '0' : arreglo[j + 1].PricesLevels[position][key])) {
                        [arreglo[j], arreglo[j + 1]] = [arreglo[j + 1], arreglo[j]];
                    }
                }
            }
        } else {
            for (let i = 0; i < l; i++) {
                for (let j = 0; j < l - 1 - i; j++) {
                    if ((arreglo[j].PricesLevels[position][key] === '-' ? '0' : arreglo[j].PricesLevels[position][key]) < (arreglo[j + 1].PricesLevels[position][key] === '-' ? '0' : arreglo[j + 1].PricesLevels[position][key])) {
                        [arreglo[j], arreglo[j + 1]] = [arreglo[j + 1], arreglo[j]];
                    }
                }
            }
        }

        this.setState({ ProductsFilter: arreglo, flag: !this.state.flag })
    }

    calculateNewPrice(e) {
        let id = e.target.id.split('_')

        if (id.length === 3) {
            let temporal = this.state.ProductsFilter
            let temporalG = this.state.Products
            const index = getIndexElement(temporal, 'ItemCode', id[1])
            const index2 = getIndexElement(temporalG, 'ItemCode', id[1])
            if (index !== -1 && index2 !== -1) {
                let Element = temporal[index]
                let Element2 = temporalG[index2]
                Element.Change = true
                Element2.Change = true
                const indexPrice = getIndexElement(Element.PricesLevels, 'PriceLevel', id[2])
                const indexPrice2 = getIndexElement(Element2.PricesLevels, 'PriceLevel', id[2])
                if (indexPrice !== -1 && indexPrice2 !== -1) {
                    let temporalPrices = Element.PricesLevels[indexPrice]
                    let UnitCost = Element.UnitCost
                    let UnitPrice = Number(e.target.value)
                    temporalPrices.NewLevelCost = Number(e.target.value)
                    if ((Number(UnitPrice)) > 0) {
                        temporalPrices.NewRealMargin = ((Number(UnitPrice) - Number(UnitCost)) / (Number(UnitPrice))) * 100
                    } else {
                        temporalPrices.NewRealMargin = 0
                    }


                    Element.PricesLevels[indexPrice] = temporalPrices
                    Element2.PricesLevels[indexPrice2] = temporalPrices
                }
                temporal[index] = Element
                temporalG[index2] = Element2
                this.setState({ ProductsFilter: temporal, Products: temporalG })

            }
        }
    }


    checkFilter(id, element) {
        //console.log("id:", id, " elemento:", element)
        const checkbox = document.getElementById(id);
        let count = 0
        if (element.Level === '0' && checkbox.checked === true) {
            const checkboxList = document.getElementsByClassName('PricesLevels')
            for (const checkbox of checkboxList) {
                checkbox.checked = true;
                count++
            }

        } else if (element.Level === '0' && checkbox.checked === false) {
            const checkboxList = document.getElementsByClassName('PricesLevels')
            for (const checkbox of checkboxList) {
                checkbox.checked = false;

            }

        } else {

            let cond = true
            const checkboxList = document.getElementsByClassName('PricesLevels')
            for (const checkbox of checkboxList) {
                if ((!checkbox.checked) && (checkbox.id !== 'CheckChangeMarginPrice0')) {
                    cond = false
                    break
                }
            }
            for (const checkbox of checkboxList) {
                if (checkbox.checked && checkbox.id !== 'CheckChangeMarginPrice0') {
                    count++
                }
            }

            let all = document.getElementById('CheckChangeMarginPrice0')
            if (all) {
                all.checked = cond
            }


        }
        this.setState({ minwidth: (120 * count) + 'vh' })
        this.FilterBySelectedPricesLevels()
    }

    FilterBySelectedPricesLevels() {
        const checkboxList = document.getElementsByClassName('PricesLevels')
        let PricesLevels = []
        for (const PriceLevel of checkboxList) {
            if (PriceLevel.checked) {
                PricesLevels.push(PriceLevel.value)
            }
        }
        let temporalHeaders = []
        for (const Level of PricesLevels) {
            const index = getIndexElement(this.state.AuxTableHeaders, 'Level', Level)
            if (index !== -1) {
                temporalHeaders.push(this.state.AuxTableHeaders[index])
            }
        }

        let temporalProducts = []
        for (const Item of this.state.Products.slice(this.state.firstIndex, this.state.lastIndex)) {
            let newPricesLevels = []
            for (const Level of PricesLevels) {
                const index = getIndexElement(Item.PricesLevels, 'PriceLevel', String(Level))

                if (index !== -1) {
                    newPricesLevels.push(Item.PricesLevels[index])
                }
            }

            temporalProducts.push({
                ItemCode: Item.ItemCode,
                ItemCodeDesc: Item.ItemCodeDesc,
                ProductLine: Item.ProductLine,
                UnitCost: Item.UnitCost,
                Change: Item.Change,
                PricesLevels: newPricesLevels,
                LastDueDate: Item.LastDueDate
            })
        }



        this.setState({ TableHeaders: temporalHeaders, ProductsFilter: temporalProducts })
        this.searchPriceMargin(this.state.textFilter)

    }

    getNewPrices() {
        let temporal = []
        for (const Item of this.state.Products) {

            if (Item.Change) {
                for (const Level of Item.PricesLevels) {
                    temporal.push({ ItemCode: Item.ItemCode, Level: Level.PriceLevel, NewCost: Level.NewLevelCost })
                }
            }
        }

        return temporal
    }
    handleModalOpen = async () => {
        this.getMarginPricesHeader()
        await this.setState({ showModal1: true })
    }

    handleModalClose = () => {
        this.setState({ showModal1: false })
    }

    async getMarginPricesHeader() {

        this.ModalLoading.current.showState(true);
        const data = {
            IdCompany: Number(getValueCookie('CompanyId'))
        }
        const result = await getInformationWithData('/Items/Get/NewMarginsHeader', data)
        if (result.status.code === 1) {
            this.setState({ MarginPricesHistoryHeader: result.data })
        } else {
            this.setState({ MarginPricesHistoryHeader: [] })
        }
        this.ModalLoading.current.showState(false);
        //this.searchPriceMargin()
    }

    async SaveWork() {
        this.ModalLoading.current.showState(true)
        const data = {
            NewWork: this.state.NewWork,
            IdCompany: Number(getValueCookie('CompanyId')),
            Detail: this.state.Products,
            UserName: getValueCookie('userName'),
            InternalId: this.state.InternalId,
            Date: getActualDateQuery()
        }
        console.log(this.state.Detail)
        const result = await create_Delete_Update_Information('/Items/Save/NewMargins', data)
        this.ModalLoading.current.showState(false)
        if (result.status.code === 1) {
            confirmCloseAlert('correct', 'Information Saved Successfully!')
        } else {
            confirmCloseAlert('incorrect', 'Whoops something was wrong. Try again!')
        }
    }

    async getMarginPriceDetail(InternalId) {
        let PricesLevels = [{ name: 'All', Level: '0' }]
        this.handleModalClose()
        this.ModalLoading.current.showState(true);
        const data = {
            IdHeader: InternalId,
            IdCompany: Number(getValueCookie('CompanyId'))
        }
        console.log(data)
        const result = await getInformationWithData('/Items/Get/NewMarginsDetail', data)

        if (data.IdCompany === 3) {
            if (result.status.code === 1) {
                let temporal = []

                for (const item of result.data) {
                    const index = getIndexElement(temporal, 'ItemCode', item.ItemCode)
                    if (index === -1) {
                        const it = {
                            ItemCode: item.ItemCode,
                            ItemCodeDesc: item.ItemCodeDesc,
                            ProductLine: item.ProductLineDesc,
                            UnitCost: item.LastTotalUnitCost,
                            Change: false,
                            PricesLevels: []

                        }
                        const priceLev = {
                            PriceLevel: String(item.CustomerPriceLevel),
                            LevelCost: item.DiscountMarkup1 === 0 ? '-' : item.DiscountMarkup1,
                            RealMargin: item.DiscountMarkup1 === 0 ? '-' : ((Number(item.DiscountMarkup1) - Number(item.LastTotalUnitCost)) / (Number(item.DiscountMarkup1))) * 100,
                            NewLevelCost: item.DiscountMarkup1 === 0 ? 0 : item.NewUnitPrice,
                            NewRealMargin: item.DiscountMarkup1 === 0 ? 0 : item.NewMarkUp

                        }
                        it.PricesLevels.push(priceLev)
                        temporal.push(it)
                    } else {
                        const priceLev = {
                            PriceLevel: String(item.CustomerPriceLevel),
                            LevelCost: item.DiscountMarkup1 === 0 ? '-' : item.DiscountMarkup1,
                            RealMargin: item.DiscountMarkup1 === 0 ? '-' : ((Number(item.DiscountMarkup1) - Number(temporal[index].UnitCost)) / (Number(item.DiscountMarkup1))) * 100,
                            NewLevelCost: item.DiscountMarkup1 === 0 ? 0 : item.NewUnitPrice,
                            NewRealMargin: item.DiscountMarkup1 === 0 ? 0 : item.NewMarkUp
                        }
                        temporal[index].PricesLevels.push(priceLev)
                    }
                }
                let headers = []
                for (const item of temporal) {
                    for (const pricelevel of item.PricesLevels) {
                        const index = getIndexElement(headers, 'Level', pricelevel.PriceLevel)
                        const index2 = getIndexElement(PricesLevels, 'Level', pricelevel.PriceLevel)
                        if (index === -1) {
                            const head = {
                                Level: pricelevel.PriceLevel,
                                Title1: "Level " + pricelevel.PriceLevel,
                                Title2: "Real Mark-Up Level " + pricelevel.PriceLevel,
                                Title3: "New Level " + pricelevel.PriceLevel,
                                Title4: "New Real Mark-Up Level " + pricelevel.PriceLevel,
                            }
                            headers.push(head)
                        }
                        if (index2 === -1) {
                            PricesLevels.push({ name: 'Price Level ' + pricelevel.PriceLevel, Level: String(pricelevel.PriceLevel) })
                        }
                    }


                }
                for (const item of temporal) {
                    if (item.PricesLevels.length !== headers.length) {
                        for (const head of headers) {
                            const index = getIndexElement(item.PricesLevels, 'PriceLevel', head.Level)
                            if (index === -1) {
                                const priceLev = {
                                    PriceLevel: head.Level,
                                    LevelCost: '-',
                                    RealMargin: '-',
                                    NewLevelCost: 0,
                                    NewRealMargin: 0
                                }
                                item.PricesLevels.push(priceLev)
                            }
                        }
                    }
                }
                temporal = await ItemDesc(temporal, 'ItemCodeDesc', 'ItemCode')
                this.setState({ InternalId: InternalId, Products: temporal, ProductsFilter: temporal.slice(this.state.firstIndex, this.state.lastIndex), TableHeaders: headers, PricesLevels: PricesLevels, AuxTableHeaders: headers, minwidth: (headers.length * 120) + 'vh', NewWork: false, textFilter: '' })
                document.getElementById("CheckChangeMarginPrice0").checked = true;
                this.checkFilter("CheckChangeMarginPrice0", { name: 'All', Level: '0' })
            }
        }

        this.ModalLoading.current.showState(false);
        this.pagination()
    }

    pagination() {
        const temp = []
        for (let i = 1; i <= Math.ceil(this.state.Products.length / this.state.ProductsPerPage); i++) {
            temp.push(i)
        }
        //console.log("hola temp:",temp,"length",this.state.ProductsFilter)
        this.setState({ pageNumers: temp })
    }

    generatePageNumbers() {
        //console.log("generate pagenumber",this.props.pageNumers)
        const pageNumers = this.state.pageNumers
        const { currentPage } = this.state;
        const totalPages = pageNumers.length;

        if (totalPages <= 4) {
            return pageNumers;
        }

        if (currentPage <= 2) {
            return [...pageNumers.slice(0, 2), '...', totalPages];
        }

        if (currentPage >= totalPages - 1) {
            return [...pageNumers.slice(-4)];
        }

        return [currentPage - 1, currentPage, "...", totalPages];
    }

    async onPreviosPage() {
        await this.setState({ currentPage: this.state.currentPage - 1 })
        await this.setState({ lastIndex: this.state.currentPage * this.state.ProductsPerPage })
        await this.setState({ firstIndex: this.state.lastIndex - this.state.ProductsPerPage })
        this.setState({ ProductsFilter: this.state.Products.slice(this.state.firstIndex, this.state.lastIndex) })
        this.searchPriceMargin(this.state.textFilter)
    }

    async onNextPage() {
        await this.setState({ currentPage: this.state.currentPage + 1 })
        await this.setState({ lastIndex: this.state.currentPage * this.state.ProductsPerPage })
        await this.setState({ firstIndex: this.state.lastIndex - this.state.ProductsPerPage })
        this.setState({ ProductsFilter: this.state.Products.slice(this.state.firstIndex, this.state.lastIndex) })
        //console.log("aber la word",this.state.textFilter)
        this.searchPriceMargin(this.state.textFilter)
    }

    async onSpecificPage(noPage) {
        await this.setState({ currentPage: noPage })
        await this.setState({ lastIndex: this.state.currentPage * this.state.ProductsPerPage })
        await this.setState({ firstIndex: this.state.lastIndex - this.state.ProductsPerPage })
        this.setState({ ProductsFilter: this.state.Products.slice(this.state.firstIndex, this.state.lastIndex) })
        this.searchPriceMargin(this.state.textFilter)
    }
    render() {
        const minWidth = this.state.minwidth
        const hasData = this.state.Products.length > 0

        const primaryBtnStyle = { background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', border: 'none', borderRadius: '10px', color: 'white', padding: '0.65rem 1.25rem', fontWeight: 600, fontSize: '0.9375rem', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.5rem', width: '100%', justifyContent: 'center' }
        const secondaryBtnStyle = { background: '#F1F5F9', border: '1.5px solid #E2E8F0', borderRadius: '10px', color: '#334155', padding: '0.65rem 1.25rem', fontWeight: 600, fontSize: '0.9375rem', cursor: 'pointer', width: '100%' }
        const cardHeaderBarStyle = { background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem' }
        const cardHeaderLabelStyle = { color: 'white', fontWeight: 700, fontSize: '0.8125rem' }

        const groupStyle = (h) => ({
            background: h % 2 === 0 ? 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)' : 'linear-gradient(135deg, #1e1b4b 0%, #4338ca 100%)',
            color: 'white',
        })

        const SortIcons = () => (
            <span style={{ marginLeft: '4px', opacity: 0.6, verticalAlign: 'middle' }}><BsFileArrowUpFill size={9} /><BsFileArrowDownFill size={9} /></span>
        )

        return (
            <div className="dash-page container-fluid pb-5" style={{ paddingTop: '1.5rem', minHeight: '100vh', background: '#F8FAFC' }}>
                <Menu Refresh={this.state.Refresh} Father={this} />
                <LoadingWindow ref={this.ModalLoading} />

                {/* ── Hero ──────────────────────────────────────────── */}
                <div style={{
                    background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 60%, #2563EB 100%)',
                    borderRadius: '16px',
                    padding: '2rem 2.5rem',
                    marginBottom: '1.5rem',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem',
                    flexWrap: 'wrap',
                }}>
                    <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '12px', padding: '0.75rem', display: 'flex' }}>
                        <AiFillDollarCircle style={{ fontSize: '1.75rem' }} />
                    </div>
                    <div>
                        <h1 style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 800, fontSize: '1.5rem', margin: 0 }}>Calculate New Price Margins</h1>
                        <p style={{ margin: 0, opacity: 0.75, fontSize: '0.875rem' }}>To start, click on Load Data below.</p>
                    </div>
                    {hasData && (
                        <div style={{ marginLeft: 'auto' }}>
                            <span style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '999px', padding: '0.35rem 1rem', fontSize: '0.8rem', fontWeight: 700 }}>
                                {this.state.Products.length.toLocaleString('en-US')} items
                            </span>
                        </div>
                    )}
                </div>

                {/* ── Actions card ──────────────────────────────────── */}
                <div className="card mb-3" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                    <div style={cardHeaderBarStyle}>
                        <span style={cardHeaderLabelStyle}>Actions</span>
                    </div>
                    <div className="card-body">
                        <div className="row g-2 d-flex justify-content-center">
                            <div className="col-6 col-md-3">
                                <button onClick={() => this.handleModalOpen()} type="button" style={secondaryBtnStyle}>View Saved Work</button>
                            </div>
                            <div className="col-6 col-md-3">
                                <button onClick={() => this.getProductsMargin()} type="button" style={primaryBtnStyle}><AiOutlineReload /> Load Data</button>
                            </div>
                            <div className="col-6 col-md-2" hidden={!hasData}>
                                <ExcelDocument archname={'Price Margins ' + getValueCookie('Company') + ' ' + getDateFromReports()} sheetname={'Price Margins ' + getValueCookie('Company')} data={ReportChangePriceMargin(this.state.AuxTableHeaders, this.state.Products, '$')} />
                            </div>
                            <div className="col-6 col-md-2" hidden={!hasData}>
                                <ExcelDocument buttonTitle={"Download Changes Only"} archname={'Price Margins ' + getValueCookie('Company') + ' ' + getDateFromReports()} sheetname={'Price Margins ' + getValueCookie('Company')} data={ReportOnlyChangePriceMargin(this.state.AuxTableHeaders, this.state.Products, '$')} />
                            </div>
                            <div className="col-12 col-md-2" hidden={!hasData}>
                                <CSVDocument disabled={false} data={this.getNewPrices()} heads={['ItemCode', 'Level', 'NewCost']} Titles={['ItemCode', 'Level', 'NewDiscountMarkUp']} name={'CSVNewPricesLevels' + getValueCookie('Company') + ' ' + getDateFromReports()} />
                            </div>
                        </div>
                    </div>
                </div>

                {/* ── Price level filter + search + save ───────────── */}
                <div className="card mb-3" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }} hidden={!hasData}>
                    <div style={cardHeaderBarStyle}>
                        <span style={cardHeaderLabelStyle}>Price Levels</span>
                    </div>
                    <div className="card-body">
                        <div className="row g-2 mb-3">
                            {this.state.PricesLevels.map((element, e) => (
                                <div className="col-6 col-sm-4 col-md-3 col-lg-2" key={e}>
                                    <label htmlFor={'CheckChangeMarginPrice' + element.Level} style={{
                                        display: 'flex', alignItems: 'center', gap: '0.5rem',
                                        background: '#F8FAFC', border: '1.5px solid #E2E8F0', borderRadius: '10px',
                                        padding: '0.5rem 0.75rem', fontSize: '0.8125rem', fontWeight: 600, color: '#334155',
                                        cursor: 'pointer', userSelect: 'none',
                                    }}>
                                        <input
                                            className="form-check-input PricesLevels"
                                            style={{ margin: 0, accentColor: '#2563EB', flexShrink: 0 }}
                                            type="checkbox"
                                            value={element.Level}
                                            name={"ChangeMarginPrice" + element.Level}
                                            defaultChecked
                                            id={'CheckChangeMarginPrice' + element.Level}
                                            onChange={() => { this.checkFilter('CheckChangeMarginPrice' + element.Level, element) }}
                                        />
                                        {element.name}
                                    </label>
                                </div>
                            ))}
                        </div>

                        <div className="row g-2 align-items-center">
                            <div className="col-12 col-md-8">
                                <div style={{ position: 'relative' }}>
                                    <AiOutlineSearch style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#94A3B8', fontSize: '1.1rem' }} />
                                    <input type="text" autoComplete='off' className="form-control" id='searchNewPriceMarginItem'
                                        value={this.state.textFilter}
                                        placeholder='Search Item by ItemCode, Line Product, Description...'
                                        onChange={(e) => this.searchPriceMargin(e.target.value)}
                                        style={{ paddingLeft: '2.25rem', height: '46px' }}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-md-4">
                                <button onClick={() => this.SaveWork()} type="button" style={primaryBtnStyle}>Save Changes</button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ── Table card ────────────────────────────────────── */}
                <div className="card" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }} hidden={!hasData}>
                    <div style={{ ...cardHeaderBarStyle, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.5rem' }}>
                        <span style={cardHeaderLabelStyle}>Margin Detail</span>
                        <span className="d-md-none" style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.72rem' }}>← Swipe to see more columns →</span>
                    </div>
                    <div className='tableFixHead'>
                        <table className={'table align-middle mb-0'} style={{ minWidth, borderCollapse: 'separate', borderSpacing: 0 }}>
                            <thead>
                                <tr>
                                    <th colSpan={4} className={styles.stickyColHead} style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', color: 'white', padding: '0.6rem 0.9rem', borderRight: '2px solid rgba(255,255,255,0.15)' }}>
                                        <div style={{ display: 'flex', gap: '6px' }}>
                                            <div style={{ flex: '0 0 26%', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', cursor: 'pointer' }} onClick={() => this.OrderPriceMargins("ItemCode")}>Item Code<SortIcons /></div>
                                            <div style={{ flex: '0 0 26%', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', cursor: 'pointer' }} onClick={() => this.OrderPriceMargins("ProductLine")}>Product Line<SortIcons /></div>
                                            <div style={{ flex: '1 1 auto', minWidth: 0 }}>Description</div>
                                            <div style={{ flex: '0 0 16%', minWidth: 0, textAlign: 'right', cursor: 'pointer' }} onClick={() => this.OrderPriceMargins("UnitCost")}>Cost<SortIcons /></div>
                                        </div>
                                    </th>
                                    {this.state.TableHeaders.map((head, h) => (
                                        <React.Fragment key={h}>
                                            <th style={{ ...groupStyle(h), padding: '0.6rem 0.5rem', cursor: 'pointer', whiteSpace: 'nowrap' }} onClick={() => this.OrderByPriceLevel(h, "LevelCost")}>{head.Title1}<SortIcons /></th>
                                            <th style={{ ...groupStyle(h), padding: '0.6rem 0.5rem', cursor: 'pointer', whiteSpace: 'nowrap' }} onClick={() => this.OrderByPriceLevel(h, "RealMargin")}>{head.Title2}<SortIcons /></th>
                                            <th style={{ ...groupStyle(h), padding: '0.6rem 0.5rem', cursor: 'pointer', whiteSpace: 'nowrap' }} onClick={() => this.OrderByPriceLevel(h, "LevelCost")}>{head.Title3}<SortIcons /></th>
                                            <th style={{ ...groupStyle(h), padding: '0.6rem 0.5rem', cursor: 'pointer', whiteSpace: 'nowrap' }} onClick={() => this.OrderByPriceLevel(h, "RealMargin")}>{head.Title4}<SortIcons /></th>
                                        </React.Fragment>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.ProductsFilter.map((item, i) => (
                                        <tr className={(item.Change ? 'bg-warning' : 'bg-light')} key={i}>
                                            <td colSpan={4} className={styles.stickyCol} style={{ background: item.Change ? '#FEF3C7' : '#FFFFFF', borderRight: '2px solid #E2E8F0', borderBottom: '1px solid #E2E8F0' }}>
                                                <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                                                    <div style={{ flex: '0 0 26%', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontWeight: 700, color: '#0F172A' }}>{item.ItemCode}</div>
                                                    <div style={{ flex: '0 0 26%', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#475569' }}>{item.ProductLine}</div>
                                                    <div style={{ flex: '1 1 auto', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', color: '#0F172A' }}>{item.ItemCodeDesc}</div>
                                                    <div style={{ flex: '0 0 16%', minWidth: 0, textAlign: 'right', fontWeight: 600, color: '#0F172A' }}>${NumberFormat(pricesFormat(item.UnitCost))}</div>
                                                </div>
                                            </td>

                                            {item.PricesLevels.map((price) => (
                                                <React.Fragment key={item.ItemCode + '_' + price.PriceLevel}>
                                                    <td className='text-end' style={{ color: '#0F172A', borderBottom: '1px solid #E2E8F0' }}>
                                                        {price.LevelCost !== '-' ? '$' + NumberFormat(pricesFormat(price.LevelCost)) : '$0'}
                                                    </td>
                                                    <td className='text-center' style={{ color: '#0F172A', borderBottom: '1px solid #E2E8F0' }}>
                                                        {price.RealMargin !== '-' ? NumberFormat(pricesFormat(price.RealMargin)) + "%" : '0.00%'}
                                                    </td>
                                                    <td className='text-center' style={{ borderBottom: '1px solid #E2E8F0' }}>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text">$</span>
                                                            <input onChange={(e) => this.calculateNewPrice(e, price.LevelCost)} type="number" step={0.05} autoComplete='off' defaultValue={pricesFormat(price.NewLevelCost)} className="form-control text-center" id={'calculatePriceMargin_' + item.ItemCode + '_' + price.PriceLevel} />
                                                        </div>
                                                    </td>
                                                    <td className='text-center' style={{ fontWeight: 700, color: '#1e3a8a', borderBottom: '1px solid #E2E8F0' }}>
                                                        {price.NewRealMargin !== '-' ? NumberFormat(pricesFormat(price.NewRealMargin)) + "%" : '0.00%'}
                                                    </td>
                                                </React.Fragment>
                                            ))}
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* ── Pagination ────────────────────────────────────── */}
                <div className="d-flex justify-content-center" hidden={!hasData} style={{ marginTop: '1rem' }}>
                    <nav aria-label="...">
                        <ul className="pagination" style={{ flexWrap: 'wrap' }}>
                            <li className={`page-item${this.state.currentPage === 1 ? ' disabled' : ''}`}>
                                <button className="page-link" onClick={() => this.onPreviosPage()}>{"<<"}</button>
                            </li>

                            {this.generatePageNumbers().map((noPage, index) => (
                                <li key={index} className={`page-item ${noPage === '...' ? 'disabled' : ''} ${noPage === this.state.currentPage ? 'active' : ''}`}>
                                    <button className="page-link" onClick={() => noPage !== '...' && this.onSpecificPage(noPage)}>
                                        {noPage}
                                    </button>
                                </li>
                            ))}

                            <li className={`page-item${this.state.currentPage === this.state.pageNumers.length ? ' disabled' : ''}`}>
                                <button className="page-link" onClick={() => this.onNextPage()}>{">>"}</button>
                            </li>
                        </ul>
                    </nav>
                </div>

                {/* ── Empty state ───────────────────────────────────── */}
                {!hasData && (
                    <div style={{ textAlign: 'center', padding: '4rem 2rem', color: '#94A3B8' }}>
                        <AiFillDollarCircle style={{ fontSize: '3rem', opacity: 0.3, marginBottom: '1rem' }} />
                        <p style={{ fontSize: '0.9rem', fontWeight: 500 }}>Click <strong style={{ color: '#1e3a8a' }}>Load Data</strong> to calculate new price margins.</p>
                    </div>
                )}

                <ModalOrders title={'History of New Margin Prices'} show={this.state.showModal1} close={() => this.handleModalClose()}>
                    <div className='tableFixHead' style={{ background: 'white', borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                        <table className='table mb-0' style={{ borderCollapse: 'separate', borderSpacing: 0 }}>
                            <thead>
                                <tr>
                                    <th style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', color: 'white', fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', padding: '12px 16px', border: 'none' }}>No</th>
                                    <th style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', color: 'white', fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', padding: '12px 16px', border: 'none' }}>Creation Date</th>
                                    <th style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', color: 'white', fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', padding: '12px 16px', border: 'none' }}>Create By</th>
                                    <th style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', color: 'white', fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', padding: '12px 16px', border: 'none' }}>Last Update Date</th>
                                    <th style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', color: 'white', fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', padding: '12px 16px', border: 'none' }}>Update By</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.MarginPricesHistoryHeader.map((header, h) => (
                                    <tr onClick={() => this.getMarginPriceDetail(header.InternalId)} key={h} className='text-center' style={{ cursor: 'pointer', borderBottom: '1px solid #E2E8F0', color: '#0F172A' }}>
                                        <td style={{ padding: '10px 16px' }}>{header.No}</td>
                                        <td style={{ padding: '10px 16px' }}>{formatInputDateQuery(header.CreationDate)}</td>
                                        <td style={{ padding: '10px 16px' }}>{header.CreateBy}</td>
                                        <td style={{ padding: '10px 16px' }}>{formatInputDateQuery(header.LastUpdateDate)}</td>
                                        <td style={{ padding: '10px 16px' }}>{header.UpdateBy}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </ModalOrders>
            </div>
        )
    }
}
